import { type FC } from 'react'
import { Spinner } from 'react-bootstrap'
import { Navigate, useParams } from 'react-router-dom'
import { type PageMetadata } from '../../models/PageMetadata'
import { TeamMembersTabs } from './TeamMembersTabs'
import { UnifiedTeamList } from './UnifiedTeamList'
import { useInviteFlowRevampEnabled } from './useInviteFlowRevampEnabled'

export interface TeamSectionProps {
  usersPage: PageMetadata | undefined
}

export const TeamSection: FC<TeamSectionProps> = ({ usersPage }) => {
  const { activeTab = null } = useParams()
  const { isEnabled, isLoading } = useInviteFlowRevampEnabled()

  if (isLoading) {
    return (
      <div className='d-flex align-items-center justify-content-center p-4'>
        <Spinner />
      </div>
    )
  }

  if (!isEnabled) {
    return <TeamMembersTabs usersPage={usersPage} />
  }

  if (activeTab === 'pending-invitations') {
    return <Navigate to={{ pathname: '/account/manage-team/members', search: '?state=pending' }} replace />
  }

  return <UnifiedTeamList usersPage={usersPage} />
}
